import React, { useState } from 'react'
import Button from 'Components/DesignSystem/Button/Button';
import { COMMON_ATTRIBUTE_VALUES } from '../utils/Constants'

type CommonAttributeValuesProps = {
    attributeValues: string[]
}

const CommonAttributeValues = ({ attributeValues }: CommonAttributeValuesProps) => {
    const [showContent, setShowContent] = useState<boolean>(false);

    const handleButtonClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.stopPropagation();
        setShowContent((prev) => !prev);
    }

    return (
        <div className="tw-flex tw-flex-col tw-w-full">
            <div className="tw-flex tw-justify-between tw-items-center">
                <div className="tw-text-ink-tertiary tw-font-semibold">{COMMON_ATTRIBUTE_VALUES}</div>
                {/*
                  * A bare <button> with no focus ring and no hit target until 2026-09-13.
                  * `subtle sm` is the quiet in-panel action; `stopPropagation` in the
                  * handler is kept verbatim — this panel renders inside an expandable
                  * row and the click must not reach it.
                  */}
                {!attributeValues || attributeValues.length === 0 ? 0 : <Button
                    variant="subtle"
                    size="sm"
                    onClick={handleButtonClick}
                    data-testid="recategorize-common-values-view-btn"
                >
                    {showContent ? 'Hide' : 'Show'}
                </Button>}
            </div>

            {showContent && attributeValues && attributeValues.length > 0 ? (
                <div className="tw-mt-2 tw-flex tw-flex-wrap tw-gap-2.5">
                    {attributeValues?.map((value) => (
                        <div key={value} className="tw-self-stretch tw-px-[5px] tw-bg-tone-neutral-tint tw-rounded-sm tw-justify-center tw-items-center tw-gap-2.5 tw-inline-flex">
                            <div className="tw-text-ink tw-text-xs">
                                {value}
                            </div>
                        </div>
                    ))}
                </div>
            ) : showContent && (
                <div className="tw-text-ink-tertiary">No attribute values available</div>
            )}
        </div>
    );
}
export default CommonAttributeValues